import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../assets/css/style.css';
import HedDan from "./Header";
import BackArow from '../../assets/img/back.svg';

const VipDan = () => {
    const navigate = useNavigate();
    const [isChecked, setIsChecked] = useState(false); // برای چک‌باکس قوانین
    const [selectedGateway, setSelectedGateway] = useState(""); // درگاه بانکی انتخاب‌شده

const Gototarms = () => {

    navigate("/panel/tarms");
    
}


    const handlePayment = async () => {
        const donetoken = localStorage.getItem("donetoken"); // دریافت توکن از localStorage

        if (!donetoken) {
            alert("خطا: توکن کاربر یافت نشد!");
            return;
        }

        if (!isChecked) {
            alert("لطفاً قوانین را قبول کنید.");
            return;
        }

        if (!selectedGateway) {
            alert("لطفاً یک درگاه بانکی انتخاب کنید.");
            return;
        }

        try {
            const response = await fetch("https://app.doneapp.ir/backend/buy-pro.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ donetoken })
            });

            const data = await response.json();

            if (data.status === "success") {
                window.location.href = `${data.redirect_url}?Token=${data.token}`; // هدایت به درگاه پرداخت
            } else {
                alert("خطا در پرداخت: " + data.message);
            }
        } catch (error) {
            alert("خطا در اتصال به سرور. لطفاً بعداً دوباره تلاش کنید.");
            console.error(error);
        }
    };

    return (
        <>
            <HedDan />

            <div className="mohtava-mine">
                <section id="add-bank" className="dir-r max-cntt-w v-100">
                    <div className="reflist-div-1 mt-30">
                        <div className="d-flex">
                            <p className="reflist-p-1" onClick={() => navigate("/panel/profile")}>
                                ارتقا سطح کاربری به ویژه
                            </p>
                            <img src={BackArow} className="reflist-img-1" alt="back" onClick={() => navigate("/panel/profile")} />
                        </div>
                    </div>

                    <div className="p-35">
                        <ul>
                            <li>مشترک گرامی، ضمن عرض تشکر و قدردانی بابت همراهی شما، قبل از هرگونه پرداخت، لطفا نکات زیر را مطالعه نمایید.</li>
                            <li>شما می‌توانید با تغییر حساب کاربری خود به سطح ویژه، از تخفیفات درج‌شده در فروشگاه به مدت یک سال استفاده نمایید.</li>
                            <li>همچنین با دریافت این اشتراک، کارت تخفیف دان را دریافت کرده و می‌توانید از سوپرمارکت‌های زنجیره‌ای سراسر کشور تخفیف بگیرید.</li>
                            <li>در صورتی که پس از عضویت، سه نفر از دوستان خود را به نرم‌افزار دعوت کنید و آن‌ها ثبت‌نام کنند، مبلغ عضویت شما به حسابتان بازگردانده خواهد شد.</li>
                        </ul>

                        <div id="tx-item" className="vip-amount-div">
                            <p className="tx-p-1">خرید اشتراک یک ساله نرم افزار دان</p>
                            <p className="tx-p-1">مبلغ قابل پرداخت: ۹.۰۰۰.۰۰۰ ریال</p>
                        </div>

                        <div className="vip-trms-div">
                            <div className="checkbox-wrapper">
                                <input
                                    type="checkbox"
                                    id="custom-checkbox"
                                    checked={isChecked}
                                    onChange={() => setIsChecked(!isChecked)}
                                />
                            </div>
                            <span onClick={Gototarms} className="color-dan-vip"> قوانین دان &zwnj; </span>
                            <span>را خوانده‌ام و قبول دارم</span>
                        </div>

                        <select className="vip-filter-1" value={selectedGateway} onChange={(e) => setSelectedGateway(e.target.value)}>
                            <option value="">انتخاب درگاه بانکی</option>
                            <option value="sep">درگاه سامان کیش</option>
                            <option value="mellat">درگاه ملت</option>
                        </select>

                        <div className="cards-div-6">
                            <button className="vip-btn-4" onClick={handlePayment}>
                                ورود به صفحه پرداخت بانک
                            </button>
                        </div>
                    </div>

                    <div className="h-100"></div>
                </section>
            </div>
        </>
    );
};

export default VipDan;
